import React from 'react'
import { Route, Switch } from 'react-router-dom'
import InvoiceItemContainer from './InvoiceItemContainer'
import InvoiceTable from './InvoiceTable'
import InvoiceValidationForm from './InvoiceValidationForm'
import Pagination from '../shared/Pagination'

/**
 * InvoiceRoute renders a tab's view:
 *  - If /path/:id → shows detail (InvoiceItemContainer + optional validation form)
 *  - Otherwise    → shows list (InvoiceTable + Pagination)
 */
export default function InvoiceRoute({
  path,
  completeTable,
  completeForm,
  validatable,
  editable,
  campaign,
  client,
  invoices,
  validatorView,
  onPageChange,
  currentPage,
  totalPages,
}) {
  /**
   * WHY render prop instead of JSX children:
   * In React Router v4/v5 (pre-5.1), <Route path="…"><JSX/></Route> passes
   * content via the `children` prop, which React Router ALWAYS renders
   * regardless of whether the path matches (it exists for animation use-cases).
   * The `render` prop is the one that gates on path match.
   */
  return (
    <Route
      path={path}
      render={() => (
        <Switch>
          {/* ── Detail view ── */}
          <Route path={`${path}/:id`} render={() => (
            <div className="invoice-layout__detail">
              <InvoiceItemContainer
                editable={editable}
                linking={path}
                campaign={campaign}
                client={client}
              />
              {validatable && <InvoiceValidationForm campaign={campaign} />}
            </div>
          )} />

          {/* ── List view ── */}
          <Route path={path} render={() => (
            <>
              <InvoiceTable
                validatable={validatorView}
                validator={validatorView}
                complete={completeTable}
                linking={path}
                invoices={invoices}
              />
              {totalPages && totalPages > 1 && (
                <div className="invoice-layout-pagination">
                  <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage + 1}
                    onPageChange={onPageChange(path)}
                  />
                </div>
              )}
            </>
          )} />
        </Switch>
      )}
    />
  )
}
